// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rv-0";